import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function MedalIcon({ className }) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            width="68"
            height="86"
            viewBox="0 0 68 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2712_1614)">
                <path
                    d="M15.2932 53.541L5.40503 75.7232L18.8139 75.1856L27.6911 85.2274L38.6079 60.7645L15.2932 53.541Z"
                    fill="#08244D"
                />
                <g style={{ 'mix-blend-mode': 'multiply' }}>
                    <path
                        d="M38.6078 60.7644L31.0964 58.4404L30.6086 78.7062L38.6078 60.7644Z"
                        fill="#B7B7B7"
                    />
                </g>
                <g style={{ 'mix-blend-mode': 'multiply' }}>
                    <path
                        d="M15.2932 53.541L12.3933 60.0535L13.3777 60.2963L15.1868 65.5947L20.8891 65.2998L24.2059 69.8438L29.5623 67.91L33.961 71.1879L38.608 60.7645L15.2932 53.541Z"
                        fill="#246340"
                    />
                </g>
                <path
                    d="M31.1938 62.4906L40.2395 85.011L49.3384 75.3594L62.8803 76.322L52.9034 51.4775L31.1938 62.4906Z"
                    fill="#08244D"
                />
                <g style={{ 'mix-blend-mode': 'multiply' }}>
                    <path
                        d="M52.9034 51.4775L31.1938 62.4906L33.9075 69.2372L34.1115 69.3846L38.6521 66.0026L44.0085 67.9278L47.3253 63.3838L53.0365 63.6786L54.8367 58.3802L55.5994 58.1894L52.9034 51.4775Z"
                        fill="#08244D"
                    />
                </g>
                <path
                    d="M34.1119 2.91577L39.1136 0.227539L43.0866 4.23386L48.6825 3.11522L51.272 8.09277L56.9566 8.63042L57.9321 14.1283L63.1999 16.2875L62.4727 21.8201L66.8625 25.4015L64.4946 30.4831L67.6074 35.1658L63.8207 39.3369L65.3815 44.7134L60.495 47.6097L60.3709 53.1943L54.8371 54.5557L53.0368 59.8542L47.3256 59.5593L44.0089 64.1033L38.6524 62.1782L34.1119 65.5601L29.5624 62.1782L24.206 64.1033L20.8892 59.5593L15.1869 59.8542L13.3778 54.5557L7.84395 53.1943L7.7198 47.6097L2.83336 44.7134L4.40305 39.3369L0.607422 35.1658L3.72019 30.4831L1.35236 25.4015L5.74217 21.8201L5.01497 16.2875L10.2827 14.1283L11.2582 8.63042L16.9428 8.09277L19.5324 3.11522L25.1283 4.23386L29.1013 0.227539L34.1119 2.91577Z"
                    fill="#F99F00"
                />
                <path
                    d="M40.1098 57.7352C54.1387 54.4975 62.8271 40.7523 59.516 27.0345C56.2049 13.3166 42.1481 4.82081 28.1193 8.05851C14.0904 11.2962 5.40196 25.0414 8.71307 38.7593C12.0242 52.4771 26.081 60.9729 40.1098 57.7352Z"
                    fill="#FFB448"
                />
                <path
                    d="M34.1118 60.0102C18.8228 60.0102 6.38062 47.8438 6.38062 32.8937C6.38062 17.9437 18.8228 5.77734 34.1118 5.77734C49.4007 5.77734 61.843 17.9437 61.843 32.8937C61.843 47.8438 49.4007 60.0102 34.1118 60.0102ZM34.1118 12.3158C22.512 12.3158 13.0673 21.5512 13.0673 32.8937C13.0673 44.2363 22.512 53.4717 34.1118 53.4717C45.7115 53.4717 55.1563 44.2363 55.1563 32.8937C55.1563 21.5512 45.7115 12.3158 34.1118 12.3158Z"
                    fill="#FFB237"
                />
                <path
                    d="M34.1119 12.3154C22.5121 12.3154 13.0674 21.5508 13.0674 32.8934C13.0674 44.236 22.5121 53.4713 34.1119 53.4713C45.7116 53.4713 55.1563 44.236 55.1563 32.8934C55.1563 21.5508 45.7116 12.3154 34.1119 12.3154Z"
                    fill="#FFC866"
                />
                <g style={{ 'mix-blend-mode': 'screen' }} opacity="0.44">
                    <path
                        d="M20.1265 48.2249L52.1766 22.3919C48.5051 16.3651 41.7918 12.3154 34.1119 12.3154C22.5121 12.3154 13.0674 21.5508 13.0674 32.8934C13.0674 38.9896 15.8077 44.4528 20.1265 48.2249Z"
                        fill="#FFB448"
                    />
                </g>
                <path
                    d="M34.1118 60.0102C18.8228 60.0102 6.38062 47.8438 6.38062 32.8937C6.38062 17.9437 18.8228 5.77734 34.1118 5.77734C49.4007 5.77734 61.843 17.9437 61.843 32.8937C61.843 47.8438 49.4007 60.0102 34.1118 60.0102ZM34.1118 12.3158C22.512 12.3158 13.0673 21.5512 13.0673 32.8937C13.0673 44.2363 22.512 53.4717 34.1118 53.4717C45.7115 53.4717 55.1563 44.2363 55.1563 32.8937C55.1563 21.5512 45.7115 12.3158 34.1118 12.3158Z"
                    fill="#FFB237"
                />
                <g style={{ 'mix-blend-mode': 'screen' }} opacity="0.44">
                    <path
                        d="M34.1118 5.77734C18.8228 5.77734 6.38062 17.9437 6.38062 32.8937C6.38062 39.0246 8.50014 44.6699 12.0209 49.2139L17.1911 45.0775C14.6104 41.6608 13.0673 37.4551 13.0673 32.8937C13.0673 21.5512 22.512 12.3158 34.1118 12.3158C40.2752 12.3158 45.8179 14.9347 49.6668 19.0797L54.837 14.9433C49.7555 9.34141 42.3593 5.77734 34.1118 5.77734Z"
                        fill="#FFB448"
                    />
                </g>
                <path
                    style={{ 'mix-blend-mode': 'screen' }}
                    opacity="0.46"
                    d="M34.1119 2.91577L39.1136 0.227539L43.0866 4.23386L48.6825 3.11522L51.272 8.09277L56.9566 8.63042L57.9321 14.1283L63.1999 16.2875L62.4727 21.8201L66.8625 25.4015L64.4946 30.4831L67.6074 35.1658L63.8207 39.3369L65.3815 44.7134L60.495 47.6097L60.3709 53.1943L54.8371 54.5557L53.0368 59.8542L47.3256 59.5593L44.0089 64.1033L38.6524 62.1782L34.1119 65.5601L29.5624 62.1782L24.206 64.1033L20.8892 59.5593L15.1869 59.8542L13.3778 54.5557L7.84395 53.1943L7.7198 47.6097L2.83336 44.7134L4.40305 39.3369L0.607422 35.1658L3.72019 30.4831L1.35236 25.4015L5.74217 21.8201L5.01497 16.2875L10.2827 14.1283L11.2582 8.63042L16.9428 8.09277L19.5324 3.11522L25.1283 4.23386L29.1013 0.227539L34.1119 2.91577Z"
                    fill="url(#paint0_radial_2712_1614)"
                />
                <path
                    opacity="0.22"
                    d="M34.1119 51.9281C44.8626 51.9281 53.5778 43.4062 53.5778 32.8938C53.5778 22.3814 44.8626 13.8594 34.1119 13.8594C23.3612 13.8594 14.646 22.3814 14.646 32.8938C14.646 43.4062 23.3612 51.9281 34.1119 51.9281Z"
                    stroke="#AF2D00"
                    strokeWidth="3.427"
                    strokeMiterlimit="10"
                />
                <g style={{ 'mix-blend-mode': 'screen' }}>
                    <path
                        d="M38.6347 41.0797H26.6714V36.5791H29.5181V27.7339C29.0037 27.864 28.2943 27.9334 27.3897 27.9334C27.1059 27.9334 26.8665 27.916 26.6714 27.89V23.5628C26.7867 23.5715 26.902 23.5802 27.035 23.5802C28.2943 23.5802 29.456 23.3374 30.5291 22.8604C31.6199 22.3748 32.4003 21.7938 32.8703 21.1348H35.8767V36.5877H38.6347V41.0883V41.0797Z"
                        fill="#EA9000"
                    />
                </g>
                <path
                    d="M40.5859 42.0338H28.6226V37.5332H31.4693V28.688C30.9549 28.8181 30.2455 28.8875 29.3409 28.8875C29.0571 28.8875 28.8177 28.8701 28.6226 28.8441V24.5169C28.7378 24.5256 28.862 24.5343 28.9862 24.5343C30.2455 24.5343 31.4072 24.2915 32.4803 23.8145C33.5711 23.3289 34.3515 22.7479 34.8215 22.0889H37.8279V37.5418H40.5859V42.0425V42.0338Z"
                    fill="#EA9000"
                />
                <g style={{ 'mix-blend-mode': 'screen' }}>
                    <path
                        d="M20.9779 19.2787H20.9956C21.0843 15.3678 24.3478 12.2286 28.3563 12.2286C24.2858 12.2286 20.9867 9.00277 20.9867 5.02246C20.9867 9.00277 17.6877 12.2286 13.6172 12.2286C17.6345 12.2286 20.8892 15.3678 20.9779 19.2787Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <radialGradient
                    id="paint0_radial_2712_1614"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.7934 22.271) scale(42.2574 41.3207)"
                >
                    <stop stopColor="#FFFF2A" />
                    <stop offset="0.15" stopColor="#FBFB29" />
                    <stop offset="0.28" stopColor="#F1F127" />
                    <stop offset="0.4" stopColor="#DFDF24" />
                    <stop offset="0.52" stopColor="#C6C620" />
                    <stop offset="0.63" stopColor="#A6A61B" />
                    <stop offset="0.74" stopColor="#7E7E14" />
                    <stop offset="0.85" stopColor="#50500D" />
                    <stop offset="0.95" stopColor="#1B1B04" />
                    <stop offset="1" />
                </radialGradient>
                <clipPath id="clip0_2712_1614">
                    <rect
                        width="67"
                        height="85"
                        fill="white"
                        transform="translate(0.607422 0.227539)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

MedalIcon.propTypes = propTypes;
MedalIcon.defaultProps = defaultProps;

export default MedalIcon;
